import { AsyncPipe } from '@angular/common';
import { AfterContentInit, Component, OnInit, ViewChild, inject } from '@angular/core';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { RouterOutlet } from '@angular/router';
import { safeAny } from '@scb-lib/index';
import { environment } from '@scbt-env/environment';
import { BUILD_TYPES } from '@scbt-lib/index';
import { A2hsService } from '@scbt-shared/services/a2hs.service';
import { AuthService } from '@scbt-shared/services/auth.service';
import { StateService } from '@scbt-shared/services/state.service';
import { SWService } from '@scbt-shared/services/sw.service';
import { TitleService } from '@scbt-shared/services/title.service';
import { UIService } from '@scbt-shared/services/ui.service';
import { ToastMessageComponent } from '@scbt-shared/toast/toast-message/toast-message.component';
import { addToastMsg, TOAST_TYPES } from '@scbt-shared/toast/toast-system';
import { combineLatest } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import semverGt from 'semver/functions/gt';
import { LoadingComponent } from './_shared/cmp/loading/loading.component';
import { SclobySyncPanelComponent } from './_shared/cmp/scloby-sync-panel/scloby-sync-panel.component';
import { ViewConsoleComponent } from './_shared/view-console-feature/view-console/view-console.component';
import { SidenavComponent } from './cmp/sidenav/sidenav.component';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	imports: [
		MatSidenavModule,
		SclobySyncPanelComponent,
		ViewConsoleComponent,
		RouterOutlet,
		SidenavComponent,
		LoadingComponent,
		AsyncPipe,
		ToastMessageComponent,
	],
})
export class AppComponent implements OnInit, AfterContentInit {
	authSrv = inject(AuthService);
	private titleSrv = inject(TitleService);
	private swSrv = inject(SWService);
	private a2hsService = inject(A2hsService);
	UISrv = inject(UIService);
	private stateSrv = inject(StateService);

	@ViewChild('sidenav', { static: true }) sidenav: MatSidenav;
	newVerWarning = false;
	private a2hsPromptShown = false;

	dbVer: string;
	environment = environment;
	background$ = this.UISrv.backgroundTaskRunning().pipe(map((v) => v > 0));
	loaderVisible$ = this.UISrv.loaderOvVisible();

	constructor() {
		this.worker_update();
	}

	ngOnInit() {
		this.UISrv.setSidenav(this.sidenav);

		this.stateSrv
			.listenAppVersionFromDb()
			.pipe(
				filter((d) => !!d),
				tap((dbVer) => {
					this.dbVer = dbVer;
					if (environment.buildType === BUILD_TYPES.prod && semverGt(dbVer, environment.version)) {
						this.newVerWarning = true;
					} else {
						this.newVerWarning = false;
					}
				})
			)
			.subscribe();
	}

	ngAfterContentInit() {
		// deferred after app loaded
		setTimeout(() => {
			this.titleSrv.startTitleChange();
			this.a2hsService.startListenCanInstall();
			this.a2hs_CheckIfDisplayPrompt();

			// Listen to tab events to enable outlines (accessibility improvement)
			document.body.addEventListener(
				'keyup',
				(e) => {
					let isTab: boolean;
					if (e.key !== undefined) {
						isTab = e.key === 'Tab';
					} else {
						isTab = (e.which || e.charCode || e.keyCode || 0) === 9;
					}
					if (isTab) {
						document.documentElement.classList.remove('no-focus-outline');
					}
				},
				false
			);
		});
	}

	worker_update() {
		this.swSrv.swUpdateAvailable$.pipe(filter((evt) => !!evt)).subscribe((event) => {
			const appData = event.latestVersion.appData as safeAny;
			console.log('Update avaliable:', appData?.version);
			addToastMsg(`E' disponibile nuova versione (${appData.version})`, {
				type: TOAST_TYPES.info,
				duration: -1,
				actions: [
					{
						label: 'RICARICA',
						action: () => {
							window.location.reload();
							location.reload();
						},
					},
				],
			});
		});
	}
	a2hs_CheckIfDisplayPrompt() {
		combineLatest([this.authSrv.user$, this.a2hsService.canInstall()])
			.pipe(
				tap(([user, canInstall]) => {
					if (user && canInstall && !this.a2hsPromptShown && !this.a2hsService.isDontAskAgain()) {
						this.a2hsPromptShown = true;
						addToastMsg(`Vuoi aggiungere ${environment.appName} alla Home?`, {
							duration: 20000,
							actions: [
								{
									label: 'AGGIUNGI',
									action: () => {
										this.a2hsService.displayPrompt();
									},
								},
								{
									label: 'NON CHIEDERE PIÙ',
									action: () => {
										this.a2hsService.setDontAskAgain();
									},
								},
							],
						});
					}
				})
			)
			.subscribe();
	}
}
